// Currency Exchanges State

export default {
  currencyExchangesList: [],
  currencyExchangeInfo: {}
}
